import type { MeResponse } from '@expeditor/shared';

type Role = MeResponse['role'];

/**
 * Возвращает путь, на который надо редиректить пользователя по его роли.
 *
 * Используется:
 *  - после успешного логина в LoginPage / RegisterPage;
 *  - в HomeRedirect (catch-all `*` и index-маршруты).
 */
export function homeRouteForRole(role: Role | undefined | null): string {
  switch (role) {
    case 'CLIENT':
      return '/cabinet/profile';
    case 'MANAGER':
      return '/manager/orders';
    case 'ADMIN':
    case 'AUDITOR':
      return '/audit';
    default:
      return '/login';
  }
}

/**
 * Проверяет, доступен ли путь для роли. Используется в LoginPage:
 * если пользователь шёл на URL вне своей зоны (например, менеджер открыл ссылку
 * клиентского кабинета), ProtectedRoute сохранит `from`. После логина мы НЕ
 * хотим направлять менеджера на /cabinet/profile — он получит 403. Поэтому
 * сверяем from с ролью и игнорируем если не подходит.
 */
export function isPathAllowedForRole(path: string, role: Role): boolean {
  // /cabinet/* — только CLIENT.
  if (path.startsWith('/cabinet')) return role === 'CLIENT';
  // /manager/* — staff (MANAGER + ADMIN + AUDITOR).
  if (path.startsWith('/manager')) {
    return role === 'MANAGER' || role === 'ADMIN' || role === 'AUDITOR';
  }
  // /audit/* — только ADMIN/AUDITOR.
  if (path.startsWith('/audit')) return role === 'ADMIN' || role === 'AUDITOR';
  // /login и /register — для всех, остальное считаем разрешённым.
  return true;
}
